import { render, staticRenderFns } from "./call-back-attempts.vue?vue&type=template&id=2664ea2e&scoped=true"
import script from "./call-back-attempts.vue?vue&type=script&lang=js"
export * from "./call-back-attempts.vue?vue&type=script&lang=js"
import style0 from "./call-back-attempts.vue?vue&type=style&index=0&id=2664ea2e&prod&lang=css"
import style1 from "./call-back-attempts.vue?vue&type=style&index=1&id=2664ea2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664ea2e",
  null
  
)

export default component.exports